
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"13","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.6 2.287h-1.024l-.256-.762a2.302 2.302 0 00-.881-1.108A2.482 2.482 0 0010.048 0H5.952a2.48 2.48 0 00-1.4.433c-.408.28-.713.676-.872 1.13l-.256.763H2.4c-.637 0-1.247.24-1.697.67A2.234 2.234 0 000 4.612v6.1c0 .606.253 1.188.703 1.617.45.429 1.06.67 1.697.67h11.2a2.46 2.46 0 001.697-.67c.45-.429.703-1.01.703-1.617v-6.1a2.194 2.194 0 00-.171-.887 2.28 2.28 0 00-.518-.755 2.408 2.408 0 00-.784-.506 2.503 2.503 0 00-.927-.178zm.8 8.387a.745.745 0 01-.235.54.82.82 0 01-.565.223H2.4a.82.82 0 01-.566-.223.745.745 0 01-.234-.54v-6.1c0-.201.084-.395.234-.538a.82.82 0 01.566-.224H4a.83.83 0 00.491-.13.768.768 0 00.309-.388l.432-1.25a.767.767 0 01.292-.377.827.827 0 01.468-.142h4.096a.84.84 0 01.468.142.767.767 0 01.292.376l.432 1.25a.765.765 0 00.276.366.825.825 0 00.444.153h1.6a.82.82 0 01.565.224c.15.143.235.337.235.539v6.1zM8 3.813c-.633 0-1.252.18-1.778.514a3.086 3.086 0 00-1.179 1.37 2.917 2.917 0 00-.182 1.761c.124.592.429 1.135.876 1.562a3.252 3.252 0 001.639.834c.62.118 1.264.058 1.848-.173a3.172 3.172 0 001.437-1.123 2.95 2.95 0 00.539-1.695 2.98 2.98 0 00-.938-2.156A3.281 3.281 0 008 3.812zm0 4.575c-.317 0-.626-.09-.89-.257a1.543 1.543 0 01-.588-.684 1.459 1.459 0 01-.091-.881c.061-.296.214-.568.437-.781.224-.213.51-.359.82-.417.31-.06.632-.03.924.086.292.116.542.311.718.562.176.25.27.546.27.847 0 .405-.169.792-.469 1.078A1.64 1.64 0 018 8.387z","fill":"currentColor"}})])
          )
        }
      }
    